export default {
  datagrid: {
    fixed: true,
    fixedPosition: 'right',
    pageSize: 10,
    buttonsWidth: '50px',
  },
};
